import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TabState, deepCopy } from 'na-lib';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { languagesList, languagesList_ } from 'na-lib';
import { Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { SettingsService } from '../../service/settings.service';
import { CommentsService } from '../../service/comments.service';
import { TranslationsDPPService } from '../../service/translations-dpp.service';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'app-pass-templates-settings-edit',
    templateUrl: './pass-templates-settings-edit.component.html',
    styleUrls: ['./pass-templates-settings-edit.component.css'],
    standalone: false
})

export class PassTemplatesSettingsEditComponent {
  passData:any
  passEditForm!:FormGroup
  oldData:any
  contextId:any
  languagesList = languagesList
  languagesPass:any=[]
  oldLanguages:any
  languages:any
  firstLanguageBeforeChange:any
  contextLanguages
  firstLanguageAfterChange:string
  widgetsBeforeChange:any
  languagesPassAfterChanges:any
  firstPassDataLanguage:string

  filterControl = new FormControl('');
  filteredLanguages: [string, string][] = [];
  defaultLanguageChanged = false;
  tabs: TabState[] = [];
  activeTabId: string = 'main';

  constructor(public dialogRef: MatDialogRef<PassTemplatesSettingsEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any[],
    private fb: FormBuilder,
    private dialog: MatDialog,
    private translateService:TranslateService,
    private settingsService:SettingsService,
    private commentService:CommentsService,
    private dppTranslations:TranslationsDPPService){
      dialogRef.disableClose = true;
      const currentLang = this.translateService.currentLang() ?? 'en';
      this.languagesList = deepCopy(languagesList_[currentLang])
  }

  ngOnInit():void{
    this.contextLanguages = deepCopy(this.settingsService.languagesContexts$)
    this.passData=deepCopy(this.data[0])
    this.oldData=deepCopy(this.data[0])
    this.contextId=deepCopy(this.data[1])
    this.tabs = (deepCopy(this.data[2]))
    this.activeTabId = deepCopy(this.data[3])
    this.languages = Object.entries(this.languagesList)
    this.languages.sort( (a,b) => { return a[1].toLowerCase().localeCompare(b[1].toLowerCase());})

    if(this.passData.languages){
      if(this.passData.languages.length!=0){
        this.firstPassDataLanguage = this.passData.languages[0]
        this.firstLanguageBeforeChange = this.passData.languages[0]
        this.firstLanguageAfterChange = this.passData.languages[0]
      }
      this.languagesPass = deepCopy(this.passData.languages)
      this.languagesPassAfterChanges = this.languagesPass
      this.oldLanguages = deepCopy(this.passData.languages)
    }else{
      this.languagesPass= []
    }

    if(this.passData.widgets)
      this.widgetsBeforeChange = deepCopy( this.passData.widgets)

    this.passEditForm = this.fb.group({
      id:[this.passData.id],
      widgets:[this.passData.widgets],
      contextId:[this.passData.contextId],
      translations:[this.passData.translations],
      theme: [this.passData.theme],
      comment:[this.passData.comment],
      name:[this.passData.name, Validators.required],
      templateName:[this.passData.templateName],
      contentType:[this.passData.contentType],
      customer:[this.passData.customer],
      tridyId:[this.passData.tridyId],
      languages:[this.passData.languages ? this.passData.languages : [] ],
      enableShoppingCart: [this.passData.enableShoppingCart],
      enableCustomerLogin: [this.passData.enableCustomerLogin]
    })

    this.passEditForm.get('languages')?.valueChanges.subscribe( newLanguages => {
      if(newLanguages.length!=0){
        const newFirstLanguage = newLanguages[0]
        this.firstLanguageAfterChange = newFirstLanguage
      }else{
        //check contextlanguages
        if(this.contextLanguages && this.contextLanguages.length!= 0){
          const newFirstLanguage = this.contextLanguages[0]
          // this.languagesPassAfterChanges = newFirstLanguage
          this.firstLanguageAfterChange = newFirstLanguage
        }
      }
    })

    // Initialize filteredLanguages with full list initially
  this.filteredLanguages = this.languages;

  // Update filteredLanguages when filter changes
  this.filterControl.valueChanges.subscribe(filterValue => {
    const filter = filterValue?.toLowerCase() || '';
    this.filteredLanguages = this.languages.filter(lang => lang[1].toLowerCase().includes(filter));
  });

  }

setDefaultLanguage(selectedLang: string) {
  if (selectedLang && this.languagesPass.includes(selectedLang)) {
    if (selectedLang !== this.languagesPass[0]) {
      this.defaultLanguageChanged = true;
    } else {
      this.defaultLanguageChanged = false;
    }

    this.languagesPass = this.languagesPass.filter(lang => lang !== selectedLang);
    this.languagesPass.unshift(selectedLang);

    this.passEditForm.get('languages')?.setValue(this.languagesPass);
  }
}

  toggleLanguageOfPass(lang) {
    const languages = this.passEditForm.value.languages || [];
    const index = languages.indexOf(lang);

    if (index === -1) {
      languages.push(lang);
    } else {
      languages.splice(index, 1);
    }

    this.languagesPass = languages;
    this.passEditForm.patchValue({ languages });
  }

  onCancelEdit(){
    this.dialogRef.close([false,this.oldData])
  }

  onSaveEdit(){
    const tabs = this.tabs.filter(t => t.id != this.activeTabId)
    const languages = this.languagesPass ?? this.contextLanguages
    if(this.firstLanguageBeforeChange != this.firstLanguageAfterChange){
      this.commentService.progressSpin.emit(true)

      //update selectedTab with new translations, widgets content
      const selectedTab = this.dppTranslations.updateWidgetsWithNewDefaultLanguage( this.firstPassDataLanguage, this.firstLanguageAfterChange, this.widgetsBeforeChange, this.passEditForm.value.translations ? this.passEditForm.value.translations : {},  languages)
      this.passEditForm.patchValue( {translations: selectedTab.translations, widgets: selectedTab.widgets})

      //update othersTabs with new translations, widgets content
      tabs.forEach( tab => {
        const {translations, widgets} = this.dppTranslations.updateWidgetsWithNewDefaultLanguage( this.firstPassDataLanguage, this.firstLanguageAfterChange, tab.widgets, tab.translations ? tab.translations : {},  languages)
        tab.widgets = widgets
        tab.translations = translations
        tab.languages = languages
      })

      this.dialogRef.close([true,this.passEditForm.value, tabs])
      this.commentService.progressSpin.emit(false)
    }else{
      tabs.forEach( tab => { tab.languages = languages })
      this.dialogRef.close([true,this.passEditForm.value, tabs])
    }
    // remove empty strings?
  }

}